$.fn.hasAncestor = function(a) {
    return this.filter(function() {
        return !!$(this).closest(a).length;
    });
};

var QuickNav = function() {
    return {
        init: function() {
        	if ($(".quick-nav").length  == 1) {
                var i = $(".quick-nav"),
                    n = i.find(".quick-nav-trigger");
                
                $(document).on("click", function(n) {
                    !$(n.target).is(".quick-nav-trigger") && !$(n.target).is(".quick-nav-trigger span") && !$(n.target).hasAncestor(".modal").length && !$(n.target).closest('.notrigger').length /*&& $('.modal.fade.in').modal('hide')*/ && i.removeClass("nav-is-visible");
                    
                    i.parent().addClass('ie_force_restyle').removeClass('ie_force_restyle');
                });
                    
                n.on("click", function(e) {
//		                
                        e.preventDefault(); 
                        i.toggleClass("nav-is-visible");
                        i.parent().addClass('ie_force_restyle').removeClass('ie_force_restyle');
                        
                        i.find('i.fa').addClass("hide-font").removeClass("hide-font");
                        
                        if ($('html').hasClass('ie8')) {
                        	
	                        var head = document.getElementsByTagName('head')[0],
	                        style = document.createElement('style');
		                    style.type = 'text/css';
		                    style.styleSheet.cssText = ':before,:after{content:none !important}';
		                    head.appendChild(style);
		                    setTimeout(function(){
		                        head.removeChild(style);
		                    }, 0);
		                    
                        }
                        return ;
                });
            }        
/*        
            if ($(".quick-nav").length > 0) {
                var i = $(".quick-nav");
                i.each(function() {
                    var i = $(this),
                        n = i.find(".quick-nav-trigger");
                    n.on("click", function(n) {
                        n.preventDefault(), i.toggleClass("nav-is-visible")
                    })
                }), $(document).on("click", function(n) {
                    !$(n.target).is(".quick-nav-trigger") && !$(n.target).is(".quick-nav-trigger span") && !$(n.target).hasAncestor(".modal").length && !$(n.target).closest('.notrigger').length && i.removeClass("nav-is-visible");
                })
            }
*/            
        }
    }
}();
QuickNav.init();
